import * as React from 'react';
import { Link, Title3 } from '@fluentui/react-components';
import { AppConstants, OpenCopilotButton } from '@careerhub/common';
import { useRoleLibraryPageStyles } from './RoleLibraryPage.styles';
import { ProfileBlock } from '../../components/ProfileBlock/ProfileBlockV2';
import { CareerPath } from '../../components/CareerPath/CareerPathV2';
import { LevelOnePage } from '../../components/BrowseProfessions/LevelOnePage';

/** Full page view for the Role Library Experience */
const RoleLibraryPage = () => {
  const styles = useRoleLibraryPageStyles();
  return (
    <div className={styles.content}>
      <div className={styles.roleDescriptionContainer}>
        <div>
          <Title3 wrap as="h1">
            Learn about roles at Microsoft
          </Title3>
          <div className={styles.subHeaderContent}>
            The Role Library is a centralized resource for roles at Microsoft based on profession, discipline, and
            career stage. It enables the ability to seamlessly explore roles across the company, see what roles require
            similar skills for career growth, and Bookmark roles or disciplines to explore later. The site does not take
            into consideration an employee's personal skills, experience, and education.
            <div className={styles.linkContainer}>
              Microsoft's culture and values guide how we show up, collaborate, and make an impact every day. Learn more
              about Microsoft's Culture:{' '}
              <Link href={AppConstants.CultureLink} target="_blank" rel="noopener noreferrer" className={styles.link}>
                Culture - Home
              </Link>
              {', Microsoft Values: '}
              <Link href={AppConstants.ValuesLink} target="_blank" rel="noopener noreferrer" className={styles.link}>
                Values - Home
              </Link>
              {', Leadership Principles: '}
              <Link
                href={AppConstants.LeadershipPrinciplesLink}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Leadership Principles
              </Link>
              {' and for managers, Management Excellence: '}
              <Link
                href={AppConstants.ManagementExcellenceLink}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Management Excellence
              </Link>
            </div>
          </div>
        </div>
        <OpenCopilotButton />
      </div>
      <div className={styles.profileContent}>
        <ProfileBlock page="RoleLibraryPage" />
      </div>
      <div className={styles.mainContent}>
        <CareerPath />
      </div>
      <div className={styles.mainContent}>
        <LevelOnePage />
      </div>
    </div>
  );
};

export default RoleLibraryPage;
